import getDayOfWeek from "../../utils/get-day-of-week";

export function AppFooter() {
  function render() {
    return /*html*/`
    <!-- ========== FOOTER ========== -->
    <footer class="lg:ps-[260px] h-[40px] sm:h-[64px]">
      <div class="p-2 sm:p-5 flex justify-center md:justify-center items-center">
        <p class="text-xs sm:text-sm text-gray-500 dark:text-neutral-500 text-center">
          👋 On behalf of <a class="text-gray-500 dark:text-neutral-500 no-underline" href="${import.meta.env.VITE_WEB_URL}/team/" target="_blank">everyone at Feedspace</a>, thanks for stopping by &amp; have a great rest of the ${getDayOfWeek()}!
        </p>

        <!-- List -->
        <!-- <ul>
          <li
            class="inline-block relative pe-5 text-xs sm:text-sm text-gray-500 align-middle last:pe-0 last-of-type:before:hidden before:absolute before:top-1/2 before:end-2 before:-translate-y-1/2 before:w-px before:h-3.5 before:bg-gray-400 before:rotate-[18deg] dark:text-neutral-500 dark:before:bg-neutral-600"
          >
            <a
              class="hover:text-blue-600 focus:outline-none focus:underline dark:hover:text-neutral-200 cursor-pointer"
              data-feedspace="RMJnqezO0YPlzo0g"
            >
              Give Feedback
            </a>
          </li>
        </ul> -->
        <!-- End List -->
      </div>
    </footer>
    <!-- ========== END FOOTER ========== -->
    `;
  }

  return { render };
}